// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Jv3H_1iRh5-Fb5ckmoB_5 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  line-height: 64px;\n  margin: 0 10px;\n  color: #444;\n  font-size: 2em;\n}\n\n._2nn_g4a0KlL0udmgSfWzQQ {\n  float: none;\n  margin: 0 auto;\n}\n\n._1VCDzvOud01JqRfZv7Z7-f {\n  float: none;\n}\n\n.navbar>.container-fluid ._1VCDzvOud01JqRfZv7Z7-f .navbar-brand {\n  margin-left: auto;\n}\n", ""]);
// Exports
exports.locals = {
	"backBtn": "_3Jv3H_1iRh5-Fb5ckmoB_5",
	"logo": "_2nn_g4a0KlL0udmgSfWzQQ",
	"navHeader": "_1VCDzvOud01JqRfZv7Z7-f"
};
module.exports = exports;
